import extend from '@techor/extend';

// todo: split resolveConfig into a function
function extendConfig(...configs) {
    const formatConfig = (config)=>{
        const clonedConfig = extend({}, config);
        const formatDeeply = (obj)=>{
            Object.entries(obj).forEach(([key, value])=>{
                if (typeof value === 'object' && !Array.isArray(value)) {
                    formatDeeply(value);
                } else if (key && !key.startsWith('@')) {
                    obj[key] = {
                        '': value
                    };
                }
            });
        };
        [
            'components',
            'variables'
        ].forEach((key)=>{
            if (clonedConfig[key]) {
                formatDeeply(clonedConfig[key]);
            }
        });
        return clonedConfig;
    };
    const collectConfigs = (config, result = [])=>{
        if (!config) return result;
        if (config.extends?.length) {
            config.extends.forEach((ext)=>collectConfigs('config' in ext ? ext.config : ext, result));
        }
        result.push(formatConfig(config));
        return result;
    };
    const formattedConfigs = configs.reduce((acc, config)=>collectConfigs(config, acc), []);
    return formattedConfigs.reduce((extendedConfig, currentConfig)=>{
        Object.entries(currentConfig).forEach(([key, value])=>{
            if (key === 'animations' && value) {
                Object.assign(extendedConfig.animations, value);
            } else if (value) {
                extendedConfig = extend(extendedConfig, {
                    [key]: value
                });
            }
        });
        return extendedConfig;
    }, {
        animations: {},
        components: {},
        at: {},
        variables: {}
    });
}

export { extendConfig as default };
